import { SubVertical, subVerticalConfig } from './verticalService'
import { isMobileEnv } from '../utils/common'
import { getSubVerticalPath } from './index'
import { DisplayMenu } from 'common/types/entities/mongo/menu'
import { MenuType } from 'common/constants/menu'
import hostConfig from 'common/config'
import { getCategoryListingUrl, getDefaultCategoryUrl } from 'common/services/finder/menu'
import { ArrayUtils } from '@shopping/common'

export enum BannerPosition {
  TOP,
  LEFT,
  RIGHT,
  BOTTOM,
}

export interface EnvAttribute {
  order: number
  subClassName?: string
  position?: BannerPosition
}

export interface BannerAttribute {
  title: string
  subTitle?: string
  linkFn?: (subVertical?: SubVertical) => string
  className: string
  isExternal: boolean
  nClick?: string
  pc: EnvAttribute
  mobile: EnvAttribute
  isMenu: boolean
  isDefault?: boolean
}

const getEventBanner = (
  pcOrder: number,
  mobileOrder: number,
  position: BannerPosition,
  title?: string,
  subTitle?: string,
): BannerAttribute => {
  const eventBanner: BannerAttribute = {
    title: title || '이벤트',
    subTitle: subTitle || 'EVENT',
    linkFn: subVertical => `${getSubVerticalPath(subVertical)}/event?eventType=exhibition`,
    isExternal: false,
    nClick: 'eli',
    className: 'event',
    pc: {
      order: pcOrder,
    },
    mobile: {
      position,
      order: mobileOrder,
    },
    isMenu: false,
  }
  return eventBanner
}

export const BannerAttributeConfig = {
  STYLE: [
    {
      title: '여성',
      isExternal: false,
      nClick: 'womanmenu',
      className: 'women',
      pc: {
        order: 0,
      },
      mobile: {
        order: 0,
        subClassName: 'center_type',
        position: BannerPosition.TOP,
      },
      isMenu: true,
    },
    {
      title: '이벤트',
      subTitle: 'EVENT',
      linkFn: subVertical => `${getSubVerticalPath(subVertical)}/event`,
      isExternal: false,
      nClick: 'eventmenu',
      className: 'event',
      pc: {
        order: 3,
      },
      mobile: {
        order: 1,
        subClassName: 'text_type',
        position: BannerPosition.TOP,
      },
      isMenu: false,
    },
    {
      title: '수제화',
      isExternal: false,
      nClick: 'shoesmenu',
      className: 'handmadeshoes',
      pc: {
        order: 2,
      },
      mobile: {
        order: 2,
        subClassName: 'text_type',
        position: BannerPosition.TOP,
      },
      isMenu: true,
    },
    {
      title: '남성',
      subTitle: '',
      isExternal: false,
      nClick: 'manmenu',
      className: 'men',
      pc: {
        order: 1,
      },
      mobile: {
        order: 3,
        subClassName: 'center_type',
        position: BannerPosition.TOP,
      },
      isMenu: true,
    },
    {
      title: '지역별',
      subTitle: '',
      linkFn: subVertical => `${getSubVerticalPath(subVertical)}/map`,
      isExternal: false,
      nClick: 'location',
      className: 'location',
      pc: {
        order: 4,
      },
      mobile: {
        order: 4,
        position: BannerPosition.BOTTOM,
      },
      isMenu: false,
    },
    {
      title: '잇템',
      subTitle: '',
      linkFn: () => `${hostConfig.trendUri.trendShop}`,
      isExternal: true,
      nClick: 'stylepick',
      className: 'ittem',
      mobile: {
        order: 5,
        position: BannerPosition.BOTTOM,
      },
      isMenu: false,
    },
  ],
  HOME_LIVING: [
    {
      title: '공간별',
      subTitle: 'SPACE',
      isExternal: false,
      nClick: 'space',
      className: 'space_room',
      pc: {
        order: 0,
      },
      mobile: {
        order: 0,
        position: BannerPosition.LEFT,
      },
      isMenu: true,
    },
    {
      title: '테마별',
      subTitle: 'THEME',
      isExternal: false,
      nClick: 'theme',
      className: 'homeliving_theme',
      pc: {
        order: 1,
      },
      mobile: {
        order: 1,
        position: BannerPosition.LEFT,
      },
      isMenu: true,
    },
    {
      title: '@The 키친',
      isExternal: false,
      nClick: 'kitchen',
      className: 'the_kitchen',
      pc: {
        order: 3,
      },
      mobile: {
        order: 0,
        position: BannerPosition.RIGHT,
      },
      isMenu: true,
    },
    {
      title: '가구단지',
      isExternal: false,
      nClick: 'complex',
      className: 'furniture_complex',
      pc: {
        order: 2,
      },
      mobile: {
        order: 1,
        position: BannerPosition.RIGHT,
      },
      isMenu: true,
    },
    {
      title: '브랜드샵',
      subTitle: '',
      isExternal: false,
      nClick: 'brand',
      className: 'brand_shop',
      pc: {
        order: 4,
      },
      mobile: {
        order: 2,
        position: BannerPosition.RIGHT,
      },
      isMenu: true,
    },
    getEventBanner(5, 0, BannerPosition.TOP),
  ],
  HANDMADE: [
    {
      title: '작품별',
      subTitle: 'CRAFTS',
      isExternal: false,
      nClick: 'art',
      className: 'crafts',
      pc: {
        order: 0,
      },
      mobile: {
        order: 0,
        position: BannerPosition.LEFT,
      },
      isMenu: true,
    },
    {
      title: '테마별',
      subTitle: 'THEME',
      isExternal: false,
      nClick: 'theme',
      className: 'handmade_theme',
      pc: {
        order: 1,
      },
      mobile: {
        order: 1,
        position: BannerPosition.LEFT,
      },
      isMenu: true,
    },
    {
      title: '취미',
      isExternal: false,
      nClick: 'hobby',
      className: 'hobby',
      pc: {
        order: 2,
      },
      mobile: {
        order: 0,
        position: BannerPosition.RIGHT,
      },
      isMenu: true,
    },
    {
      title: '플리마켓',
      linkFn: subVertical => `${getSubVerticalPath(subVertical)}/event?eventType=fleamarket`,
      isExternal: false,
      nClick: 'fle',
      className: 'fleamarket',
      pc: {
        order: 4,
      },
      mobile: {
        order: 1,
        position: BannerPosition.RIGHT,
      },
      isMenu: false,
    },
    {
      title: '무료체험단',
      subTitle: '',
      linkFn: subVertical =>
        `${isMobileEnv ? hostConfig.freeExperienceUrl.mobile : hostConfig.freeExperienceUrl.pc}?verticalType=${
          subVerticalConfig[subVertical].vertical
        }`,
      isExternal: true,
      nClick: 'fre',
      className: 'free_trial',
      pc: {
        order: 5,
      },
      mobile: {
        order: 2,
        position: BannerPosition.RIGHT,
      },
      isMenu: false,
    },
    getEventBanner(3, 0, BannerPosition.TOP),
  ],
  STATIONERY: [
    {
      title: '아이템별',
      subTitle: 'ITEM',
      isExternal: false,
      nClick: 'items',
      className: 'stationery_items',
      pc: {
        order: 0,
      },
      mobile: {
        order: 0,
        position: BannerPosition.LEFT,
      },
      isMenu: true,
    },
    {
      title: '테마별',
      subTitle: 'THEME',
      isExternal: false,
      nClick: 'theme',
      className: 'stationery_theme',
      pc: {
        order: 1,
        position: '',
      },
      mobile: {
        order: 1,
        position: BannerPosition.LEFT,
      },
      isMenu: true,
    },
    {
      title: '동영상문방구',
      subTitle: 'VIDEO<br/>CLIP',
      isExternal: false,
      nClick: 'videoclip',
      className: 'video_clip',
      pc: {
        order: 2,
      },
      mobile: {
        order: 1,
        position: BannerPosition.RIGHT,
      },
      isMenu: true,
    },
    {
      title: '그라폴리오<br/>아트상품',
      subTitle: 'GRAFOLIO',
      linkFn: subVertical => `${getSubVerticalPath(subVertical)}/external/products`,
      isExternal: false,
      nClick: 'grafolio',
      className: 'grafolio',
      pc: {
        order: 4,
      },
      mobile: {
        order: 2,
        position: BannerPosition.RIGHT,
      },
      isMenu: false,
    },
    getEventBanner(3, 0, BannerPosition.TOP),
  ],
  FOREIGN: [
    {
      title: `${isMobileEnv ? '국가별<br/>상품보기' : '국가별'}`,
      subTitle: '유니크한 상품을<br/>국가별로 만나세요!',
      isExternal: false,
      nClick: 'region',
      className: 'region',
      pc: {
        order: 1,
      },
      mobile: {
        order: 1,
        position: BannerPosition.LEFT,
      },
      isMenu: true,
      isDefault: true,
    },
    {
      title: '한정레어템',
      subTitle: '',
      isExternal: false,
      nClick: 'rare',
      className: 'theme_ranking',
      pc: {
        order: 3,
      },
      mobile: {
        order: 1,
        position: BannerPosition.RIGHT,
      },
      isMenu: true,
    },
    {
      title: '아울렛NOW',
      subTitle: '',
      isExternal: false,
      nClick: 'outlet',
      className: 'outlet_now',
      pc: {
        order: 2,
      },
      mobile: {
        order: 2,
        position: BannerPosition.RIGHT,
      },
      isMenu: true,
    },
    {
      title: '쇼핑꿀팁',
      subTitle: '',
      linkFn: subVertical => `${getSubVerticalPath(subVertical)}/event?eventType=tip_shopping`,
      isExternal: false,
      nClick: 'stl',
      className: 'tip_shopping',
      pc: {
        order: 5,
      },
      mobile: {
        order: 3,
        position: BannerPosition.RIGHT,
      },
      isMenu: false,
    },
    {
      title: '랭킹쇼핑',
      subTitle: 'RANKING',
      linkFn: subVertical => `${getSubVerticalPath(subVertical)}/event?eventType=ranking_shopping`,
      isExternal: false,
      nClick: 'rsp',
      className: 'ranking_shopping',
      pc: {
        order: 4,
      },
      mobile: {
        order: 0,
        position: BannerPosition.TOP,
      },
      isMenu: false,
    },
    getEventBanner(6, 4, BannerPosition.RIGHT, isMobileEnv ? 'EVENT' : '이벤트', ''),
  ],
}

export const getHomMenuBy = (subVertical: SubVertical): BannerAttribute[] => {
  const sortArr = BannerAttributeConfig[subVertical].filter(value => {
    return isMobileEnv ? value.mobile : value.pc
  })

  sortArr.sort((a, b) => {
    return getSort(a) < getSort(b) ? -1 : getSort(a) > getSort(b) ? 1 : 0
  })
  return sortArr
}

const getSort = (banner: BannerAttribute): number => {
  if (isMobileEnv) return banner && banner.mobile && banner.mobile.order
  return banner && banner.pc && banner.pc.order
}

export const getBannerClassName = (banner: BannerAttribute): string => {
  return banner && banner.className
}

export const getBannerSubClassName = (banner: BannerAttribute): string => {
  if (isMobileEnv) return banner && banner.mobile.subClassName
  return banner && banner.pc.subClassName
}

export const getFrontMenuByPosition = (subVertical: SubVertical, position: BannerPosition): BannerAttribute[] => {
  const sortArr = getPosition(subVertical, position)
  sortArr.sort((a, b) => {
    return getSort(a) < getSort(b) ? -1 : getSort(a) > getSort(b) ? 1 : 0
  })
  return sortArr
}

const getPosition = (subVertical: SubVertical, position: BannerPosition): BannerAttribute[] => {
  return BannerAttributeConfig[subVertical].filter(value => {
    return isMobileEnv ? value.mobile && value.mobile.position === position : value.pc && value.pc.position === position
  })
}

export const getBannerLink = (
  subVertical: SubVertical,
  banner: BannerAttribute,
  menus: DisplayMenu[],
  secondMenus?: DisplayMenu[],
): string => {
  const { linkFn, isMenu } = banner

  if (isMenu) {
    return getMenuLink(subVertical, banner, menus, secondMenus)
  }
  return linkFn(subVertical)
}

const getMenuLink = (
  subVertical: SubVertical,
  banner: BannerAttribute,
  menus: DisplayMenu[],
  secondMenus: DisplayMenu[],
): string => {
  const { className, isDefault } = banner
  // 문방구-동영상 문방구인 경우만 예외케이스로 처리
  if (subVertical === SubVertical.STATIONERY && className === 'video_clip') {
    return getVideoClipMenuLink(secondMenus, subVertical, className)
  }

  if (isDefault) {
    return getDefaultCategoryUrl(subVertical)
  }

  const menu = menus.find(menu => menu.alias && menu.alias.toLocaleLowerCase() === className)
  if (!menu) {
    return '#'
  }
  if (menu.type === MenuType.LINK) {
    return isMobileEnv ? menu.mobileLink : menu.pcLink
  }
  return getCategoryListingUrl(subVertical, menu)
}

const getVideoClipMenuLink = (secondMenus: DisplayMenu[], subVertical: SubVertical, className: string) => {
  if (ArrayUtils.isEmpty(secondMenus)) return '#'
  const targetMenu = secondMenus.find(menu => menu.alias && className === menu.alias.toLocaleLowerCase())
  return getCategoryListingUrl(subVertical, targetMenu)
}
